import { render, staticRenderFns } from "./FlashCardFavorite.vue?vue&type=template&id=2e005b35&"
import script from "@/scripts/FlashCard/FlashCardLanding/components/FlashCardFavorite.js?vue&type=script&lang=js&"
export * from "@/scripts/FlashCard/FlashCardLanding/components/FlashCardFavorite.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports